const awsConfig = {
  // REQUIRED - Amazon Cognito Region
  region: process.env.REACT_APP_COGNITO_REGION,

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,

  // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  authenticationFlowType:
    process.env.REACT_APP_COGNITO_AUTHENTICATION_FLOW_TYPE,
};

export const awsInternalConfig = {
  // REQUIRED - Amazon Cognito Region
  region: process.env.REACT_APP_COGNITO_REGION,

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: process.env.REACT_APP_COGNITO_INTERNAL_USER_POOL_ID,

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolWebClientId:
    process.env.REACT_APP_COGNITO_INTERNAL_USER_POOL_WEB_CLIENT_ID,

  // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  authenticationFlowType:
    process.env.REACT_APP_COGNITO_AUTHENTICATION_FLOW_TYPE,
};

export default awsConfig;
